import { toFileExtension } from 'util/toFileExtension';
import {
  selectFiltersQuery,
  selectLanguage,
  selectSorting,
  selectSummaryCategoryViewMode,
} from 'util/selector/querySelector';

import { queryDto } from 'api/dto/Query.dto';
import { selectCurrentProjectId } from 'reduxStore/project/selectors';
import { ReportFormatType } from 'model/ReportFormat';
import qs from 'qs';
import { QueryType } from 'model/QueryType';

export const getFeedbackCombinedReportQuery = (
  getState: () => any,
  type: ReportFormatType,
  departmentId?: number
) => {
  const projectId = selectCurrentProjectId(getState());
  const format = toFileExtension(type);

  let filtersQuery = selectFiltersQuery(getState());

  if (filtersQuery === '?' && departmentId) {
    filtersQuery = qs.stringify(
      {
        [QueryType.Filter]: {
          [QueryType.Department]: [departmentId],
        },
      },
      { encode: false }
    );
  }

  const categoryMode = selectSummaryCategoryViewMode(getState());
  const language = selectLanguage(getState());
  const sortBy = selectSorting(getState());

  const query = queryDto.build(
    filtersQuery,
    queryDto.stringifyCategoryMode(categoryMode),
    queryDto.stringifyLanguage(language),
    queryDto.stringifySortBy(sortBy)
  );

  return {
    projectId,
    format,
    query,
  };
};
